export const OULUJARVI = {
  name: "Oulujärven ympäriajo",
  routes: [
    {
      weight_name: "routability",
      legs: [
        {
          summary: "22, Kiveslahdentie",
          steps: [],
          distance: 42431.219,
          duration: 2877.83,
          weight: 2877.83,
        },
        {
          summary: "8820, 22",
          steps: [],
          distance: 76110.984,
          duration: 4502.986,
          weight: 4502.986,
        },
        {
          summary: "5, Nikarintie",
          steps: [],
          distance: 16278.869,
          duration: 1415.353,
          weight: 1415.353,
        },
        {
          summary: "5, 28",
          steps: [],
          distance: 54311.543,
          duration: 5561.186,
          weight: 5561.186,
        },
        {
          summary: "879, Neittäväntie",
          steps: [],
          distance: 65928.359,
          duration: 5024.745,
          weight: 5024.745,
        },
      ],
      geometry: {
        coordinates: [
          [26.841269, 64.559982],
          [26.876738, 64.567413],
          [27.089916, 64.546753],
          [27.154404, 64.551735],
          [27.242168, 64.533546],
          [27.222338, 64.509041],
          [27.201763, 64.512619],
          [27.214787, 64.47802],
          [27.280323, 64.458397],
          [27.21756, 64.444206],
          [27.188334, 64.427551],
          [27.173609, 64.402397],
          [27.173443, 64.402245],
          [27.234459, 64.405945],
          [27.335808, 64.370262],
          [27.447929, 64.378181],
          [27.529613, 64.413277],
          [27.660484, 64.41333],
          [27.677923, 64.422325],
          [27.805105, 64.400032],
          [27.858641, 64.404488],
          [27.97834, 64.392273],
          [28.043625, 64.367424],
          [28.061144, 64.324791],
          [27.989389, 64.295105],
          [27.860033, 64.271706],
          [27.773323, 64.224907],
          [27.697182, 64.217735],
          [27.688616, 64.220688],
          [27.689781, 64.219589],
          [27.586143, 64.181091],
          [27.556074, 64.218475],
          [27.480158, 64.221306],
          [27.473375, 64.220299],
          [27.460884, 64.218857],
          [27.462872, 64.221779],
          [27.556074, 64.218475],
          [27.586143, 64.181091],
          [27.530428, 64.167007],
          [27.451029, 64.118317],
          [27.27565, 64.10984],
          [27.235153, 64.119423],
          [27.142206, 64.11161],
          [26.957291, 64.1157],
          [26.948978, 64.136856],
          [27.010876, 64.183136],
          [27.010996, 64.183197],
          [26.982725, 64.191032],
          [26.959208, 64.224899],
          [26.831312, 64.298477],
          [26.798328, 64.33757],
          [26.741743, 64.358055],
          [26.738203, 64.405655],
          [26.707109, 64.446663],
          [26.526638, 64.443138],
          [26.523598, 64.463997],
          [26.659296, 64.508324],
          [26.766729, 64.535431],
          [26.805567, 64.534927],
          [26.816422, 64.555344],
          [26.840622, 64.559814],
          [26.841129, 64.559937],
          [26.841269, 64.559982],
        ],
        type: "LineString",
      },
      distance: 255060.984,
      duration: 19382.1,
      weight: 19382.1,
    },
  ],
  waypoints: [
    {
      distance: 3.672,
      name: "Vaalantie",
      location: [26.841269, 64.559982],
    },
    {
      distance: 0.921,
      name: "Petäjälahdentie",
      location: [27.173609, 64.402397],
    },
    {
      distance: 3.634,
      name: "5",
      location: [27.697182, 64.217735],
    },
    {
      distance: 0.926,
      name: "Vuoreslahdentie",
      location: [27.480158, 64.221306],
    },
    {
      distance: 5.693,
      name: "Keisarintie",
      location: [27.010876, 64.183136],
    },
    {
      distance: 3.672,
      name: "Vaalantie",
      location: [26.841269, 64.559982],
    },
  ],
  code: "Ok",
  uuid: "XbwwYNC2U5Q7Bo2AzXW-W5KnZhdPsSZhN1ahGZWQ9RJ9MRhHq67iPw==",
}
